import React from "react";

//Imagenes Hero PC
import PC01 from "../Assets/paginadeinicio/seccionuno/pclapaz.jpg";
import PC02 from "../Assets/paginadeinicio/seccionuno/pcsantacruz.jpg";
import PC03 from "../Assets/paginadeinicio/seccionuno/cochapc.jpg";
import PC04 from "../Assets/paginadeinicio/seccionuno/pcuyuni.jpg";
import PC05 from "../Assets/paginadeinicio/seccionuno/pcamazonia.jpg";
import PC06 from "../Assets/paginadeinicio/seccionuno/pcpotosi.jpg";
//Imagenes Hero Laptop
import LAPTOP01 from "../Assets/paginadeinicio/seccionuno/laptoplapaz.jpg";
import LAPTOP02 from "../Assets/paginadeinicio/seccionuno/laptopsantacruz.jpg";
import LAPTOP03 from "../Assets/paginadeinicio/seccionuno/cochalaptop.jpg";
import LAPTOP04 from "../Assets/paginadeinicio/seccionuno/laptopuyuni.jpg";
import LAPTOP05 from "../Assets/paginadeinicio/seccionuno/laptopamazonia.jpg";
import LAPTOP06 from "../Assets/paginadeinicio/seccionuno/laptoppotosi.jpg";
//Imagenes Hero Tablet
import TABLET01 from "../Assets/paginadeinicio/seccionuno/tabletlapaz.jpg";
import TABLET02 from "../Assets/paginadeinicio/seccionuno/tabletsantacruz.jpg";
import TABLET03 from "../Assets/paginadeinicio/seccionuno/cochatablet.jpg";
import TABLET04 from "../Assets/paginadeinicio/seccionuno/tabletuyuni.jpg";
import TABLET05 from "../Assets/paginadeinicio/seccionuno/tabletamazonia.jpg";
import TABLET06 from "../Assets/paginadeinicio/seccionuno/tabletpotosi.jpg";
//Imagenes Hero Celular
import CELULAR01 from "../Assets/paginadeinicio/seccionuno/celularlapaz.jpg";
import CELULAR02 from "../Assets/paginadeinicio/seccionuno/celularsantacruz.jpg";
import CELULAR03 from "../Assets/paginadeinicio/seccionuno/cochacelu.jpg";
import CELULAR04 from "../Assets/paginadeinicio/seccionuno/celularuyuni.jpg";
import CELULAR05 from "../Assets/paginadeinicio/seccionuno/celularamazonia.jpg";
import CELULAR06 from "../Assets/paginadeinicio/seccionuno/celularpotosi.jpg";

import logoDelta from "../Assets/Logos/isoitipo.png";
import logoSMS from "../Assets/Logos/istotipoSMS.png";
// Iconos Estadisticas Delta
import people from "../Assets/Icons/stats/people.png";
import profesional from "../Assets/Icons/stats/profesional.png";
import stars from "../Assets/Icons/stats/Stars.png";

// Iconos Estadisticas SMS
import world from "../Assets/Icons/stats/World.png";
import person from "../Assets/Icons/stats/Person.png";
import world2 from "../Assets/Icons/stats/World2.png";

// Imagenes Confiar en Nosotros
import trust2 from "../Assets/paginadeinicio/secciontres/foto1_confiar.jpg";
import trust from "../Assets/paginadeinicio/secciontres/foto2_confiar.jpg";

//Logos Empresas Aliadas
import swiss from "../Assets/paginadeinicio/seccioncuatro/pcswiss.jpg";
import business from "../Assets/paginadeinicio/seccioncuatro/pcden.jpg";
import coworking from "../Assets/paginadeinicio/seccioncuatro/pcdcw.jpg";

const HomeContext = React.createContext();

function HomeProvider(props) {
  const heroContent = [
    {
      imagePC: PC01,
      imagePCP: LAPTOP01,
      imageTB: TABLET01,
      imageCEL: CELULAR01,
      title: "Bienvenidos a Delta Consult",
      text: "Somos una firma de servicios de auditoría y consultoría, miembro de la red SMS Latinoamérica",
      button: "Explora",
      path: "/Servicios",
    },
    {
      imagePC: PC02,
      imagePCP: LAPTOP02,
      imageTB: TABLET02,
      imageCEL: CELULAR02,
      title: "Liderando el mercado desde 1976",
      text: "Son 50 años brindando servicios de auditoría y consultoría en Bolivia",
      button: "Explora",
      path: "/Nosotros",
    },
    {
      imagePC: PC03,
      imagePCP: LAPTOP03,
      imageTB: TABLET03,
      imageCEL: CELULAR03,
      title: "Bienvenidos a Delta Consult",
      text: "Somos una firma de servicios de auditoría y consultoría, miembro de la red SMS Latinoamérica",
      button: "Explora",
      path: "/Servicios",
    },
    {
      imagePC: PC04,
      imagePCP: LAPTOP04,
      imageTB: TABLET04,
      imageCEL: CELULAR04,
      title: "Te ofrecemos servicios de calidad",
      text: "Son varios clientes de múltiples rubros los que confían en nuestra experiencia",
      button: "Explora",
      path: "/Industrias",
    },
    {
      imagePC: PC05,
      imagePCP: LAPTOP05,
      imageTB: TABLET05,
      imageCEL: CELULAR05,
      title: "Liderando el mercado desde 1976",
      text: "Son 50 años brindando servicios de auditoría y consultoría en Bolivia",
      button: "Explora",
      path: "/Industrias",
    },
    {
      imagePC: PC06,
      imagePCP: LAPTOP06,
      imageTB: TABLET06,
      imageCEL: CELULAR06,
      title: "Bienvenidos a Delta Consult",
      text: "Somos una firma de servicios de auditoría y consultoría, miembro de la red SMS Latinoamérica",
      button: "Explora",
      path: "/Industrias",
    },
  ];

  const generalStatistics = {
    logo: logoDelta,
    stats: [
      {
        icon: people,
        title: "+250",
        text: "Clientes satisfechos por gestión",
      },
      {
        icon: profesional,
        title: "+65",
        text: "Consultores asociados",
      },
      {
        icon: stars,
        title: "+20",
        text: "Premios y galardones",
      },
    ],
  };

  const smsStatistics = {
    logo: logoSMS,
    stats: [
      {
        icon: world2,
        title: "+22",
        text: "Países americanos con oficinas de SMS Latinoamerica",
      },
      {
        icon: person,
        title: "+2500",
        text: "Profesionales en red",
      },
      {
        icon: world,
        title: "+80",
        text: "Oficinas en el continente americano",
      },
    ],
  };

  const trustStatement = [
    "Contamos con el registro y vigencia en principales entes de fiscalización y control que avalan nuestra calidad",
    "Somos una firma nacional, con profesionales bolivianos con un enfoque de práctica internacional",
    "Nuestra metodología nos permite un exigente control de calidad en los productos entregados y sobre la ejecución del servicio al cliente",
    "La eficiente estructura de costos que manejamos nos permiten administrar honorarios competitivos debido a la minimización de costos ociosos e improductivos",
  ];

  const trustImages = [trust, trust2];

  const allies = [
    {
      logo: swiss,
      nombre: "SWISS CONSULT",
      descripcion: "Servicios contables de bookkeeping e impuestos.",
      url: "https://swissconsult.dcl.com.bo",
    },
    {
      logo: business,
      nombre: "DELTA ESCUELA DE NEGOCIOS",
      descripcion: "Capacitaciones empresariales y formación profesional",
      url: "https://www.facebook.com/profile.php?id=61556668987182",
    },
    {
      logo: coworking,
      nombre: "DELTA COWORKING",
      descripcion: "Espacios de trabajo y recreación empresarial.",
      url: "https://www.instagram.com/delta.coworking/",
    },
  ];
  return (
    <HomeContext.Provider
      value={{
        heroContent,
        generalStatistics,
        smsStatistics,
        trustStatement,
        trustImages,
        allies,
      }}
    >
      {props.children}
    </HomeContext.Provider>
  );
}

export { HomeContext, HomeProvider };
